import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Stack, Switch, Typography } from '@mui/material';
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded';
const STORAGE_KEY = 'helder.protectMode';
export default function ProtectModeToggle() {
    const [enabled, setEnabled] = useState(false);
    useEffect(() => {
        try {
            setEnabled(localStorage.getItem(STORAGE_KEY) === 'true');
        }
        catch {
            // localStorage unavailable — fall back to session-only state.
        }
    }, []);
    const toggle = () => {
        setEnabled((prev) => {
            const next = !prev;
            try {
                localStorage.setItem(STORAGE_KEY, String(next));
            }
            catch {
                // ignore — per-session only if storage isn't available
            }
            return next;
        });
    };
    return (_jsxs(Stack, { direction: "row", spacing: 0.75, sx: {
            position: 'fixed',
            top: 16,
            right: 20,
            zIndex: 1300,
            alignItems: 'center',
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'rgba(15, 23, 42, 0.08)',
            borderRadius: '999px',
            px: 1.25,
            py: 0.5,
            boxShadow: '0 1px 2px rgba(15, 23, 42, 0.05)',
        }, children: [_jsx(ShieldRoundedIcon, { sx: {
                    fontSize: 16,
                    color: enabled ? 'primary.main' : 'text.disabled',
                } }, void 0), _jsx(Typography, { variant: "caption", sx: {
                    fontWeight: 600,
                    color: enabled ? 'text.primary' : 'text.secondary',
                }, children: "Protect" }, void 0), _jsx(Switch, { size: "small", checked: enabled, onChange: toggle, slotProps: { input: { 'aria-label': 'Toggle protect mode' } } }, void 0)] }, void 0));
}
